<style></style>

<template>
  <v-container>
    <v-layout row justify-space-around mt-5>
      <v-flex xs6>
        <v-layout column align-content-center>

          <v-flex>
            <v-text-field label="Email" v-model="email"></v-text-field>
          </v-flex>

          <v-flex class="text-xs-center" mt-5>
            <v-btn color="info" depressed @click="saveInfo">Save</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  mounted() {
    console.log(this.userDoc);
    this.name = this.userDoc.name;
    this.email = this.userDoc.email;
  },
  methods: {
    saveInfo() {
      // let userUpdate = {
      //   name: this.name,
      //   email: this.email
      // };
      // updateUser(userUpdate);
    }
  },
  data() {
    return {
      name: "",
      email: ""
    };
  },
  components: {},
  computed: {
    ...mapGetters(["userDoc"])
  }
};
</script>
